import { Navigate } from "react-router-dom";
import { urls } from "../../urls";

export const HomeRoute = () => <Navigate to={urls.v2.home} replace />;
